export const SI_SENTRY_TAGS: Record<"solution", string> = {
    solution: "sales-intelligence",
};
